import request from '@/utils/request'

export function getPageList(data) {
    return request({
      url: 'pbsign/getPageList',
      method: 'post',
      data,
    })
  }